import MetadataProvider from "./MetadataProvider";
export default MetadataProvider;
export { useMetadata } from "./MetadataProvider";
